import { Injector, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OrderSummaryComponent } from './order-summary.component';
import { PipesModule } from '../../pipes/pipes.module';
import { DialogModule } from 'primeng/dialog';
import { createCustomElement } from '@angular/elements';
import { DirectivesModule } from '../../directives/directives.module';
import { SanitizePipeModule } from '@digistore/ds24-ui/pipes';

@NgModule({
  declarations: [OrderSummaryComponent],
  imports: [
    CommonModule,
    PipesModule,
    SanitizePipeModule,
    DialogModule,
    DirectivesModule,
  ],
  exports: [OrderSummaryComponent],
})
export class OrderSummaryModule {
  static initialize(injector: Injector) {
    const customComponent = createCustomElement(OrderSummaryComponent, {
      injector: injector,
    });
    customElements.define('ds-orderform-order-summary', customComponent);
  }
}
